<script setup lang="ts">
import { Tooltip } from 'floating-vue'

import { hasSlotContent } from '../utils'

interface Props {
  lazy?: boolean
}

defineProps<Props>()
</script>

<template>
  <!-- :distance="12" increases tooltip distance from content and avoids "blinking tooltip bug" when hovering on tooltip edge -->
  <Tooltip
    :delay="{
      show: lazy ? 1200 : 200,
      hide: 0,
    }"
    :distance="12"
    :overflowPadding="10"
    :disabled="!hasSlotContent($slots.tooltip)"
  >
    <slot />
    <template #popper>
      <slot name="tooltip" />
    </template>
  </Tooltip>
</template>
